import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface HsnSacParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface HsnSac {
    id?: number;
   hsn_sac_code: number;
    sgst: number;
    cgst:number;
    igst:number;
    type:string;
    unit:any;
    cess:number;
    unitMst?:any;
    parameters?: HsnSacParameter[];
    links?: any;
}


export abstract class HsnSacData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<HsnSac[]>;
    abstract create(url: string, data: HsnSac): Observable<HsnSac[]>;
    abstract update(url: string, data: HsnSac): Observable<HsnSac>;
    abstract delete(url: string): Observable<any>;
}
